import React from 'react';
import PropTypes from 'prop-types';

import SimpleSearch from 'components/filters/SimpleSearch';

import SortFilters from 'components/filters/SortFilters';
import styles from './styles.module.scss';

const DesktopControls = ({ filters, onFilterChange }) => (
	<div className={styles.DesktopInstituteControls}>
		<div className={styles.DesktopInstituteControls__Block}>
			<SortFilters onFilterChange={onFilterChange} currentSort={filters.sort} />

			<SimpleSearch
				onEnter={onFilterChange}
				placeholder="Поиск"
				value={filters.query}
			/>
		</div>
	</div>
);

DesktopControls.propTypes = {
	filters: PropTypes.shape({
		query: PropTypes.string,
		sort: PropTypes.string
	}),
	onFilterChange: PropTypes.func
};

DesktopControls.defaultProps = {
	filters: {}
};

export default DesktopControls;
